import chalk from 'chalk';

export class ServerError extends Error {
  constructor(message: string, error: any) {
    super(chalk.red(`${message}`), { cause: error });
  }

  get name() {
    return chalk.red(`[ERROR]`);
  }
}
